import React from 'react';
import styled from 'styled-components';
import {
  getAccessDevices,
  getAccessDeviceAriaLabel,
  ACCESS_DEVICE_SHORT_LABELS
} from '../utils/experienceDeviceAccess';

const Line = styled.div`
  font-size: ${(p) => (p.$compact ? '0.72rem' : '0.9rem')};
  font-weight: 500;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.45;
`;

const DeviceWord = styled.span`
  color: rgba(255, 255, 255, ${(p) => (p.$dimmed ? 0.45 : 0.88)});
`;

const Dot = styled.span`
  color: rgba(255, 255, 255, 0.45);
  padding: 0 0.35em;
`;

export default function AccessDeviceIcons({ experience, className, compact = false }) {
  const entries = getAccessDevices(experience);
  if (!entries.length) return null;

  return (
    <Line
      className={className}
      $compact={compact}
      aria-label={`Accessible on: ${getAccessDeviceAriaLabel(entries)}`}
    >
      {entries.map((entry, index) => {
        const word = ACCESS_DEVICE_SHORT_LABELS[entry.device] || entry.device;
        const title = entry.notRecommended ? `${entry.label} (headset recommended)` : entry.label;

        return (
          <React.Fragment key={entry.device}>
            {index > 0 && <Dot aria-hidden="true">·</Dot>}
            <DeviceWord $dimmed={entry.notRecommended} title={title}>
              {word}
            </DeviceWord>
          </React.Fragment>
        );
      })}
    </Line>
  );
}
